import { Stack, useMediaQuery, useTheme } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { authAtom, tokenAtom } from '../../../../actions/index';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import ProductItem from '../components/ProductItem';

const ProductTab = ({ username: lead_username }) => {
    const [auth] = useAtom(authAtom);
    const [token] = useAtom(tokenAtom);
    const history = useHistory();

    const [products, setProducts] = useState([]);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if the screen size is small

    const getProducts = useCallback(() => {
        if (token)
            axios.post('/products/product/get_user_products/', {
                username: lead_username
            }, { headers: { Authorization: `Token ${token}` } })
                .then(res => {
                    if (res && res.data) {
                        setProducts(res.data);
                    }
                })
                .catch((error) => {
                    console.log({ error });
                });
    }, [token, lead_username]);

    useEffect(() => {
        getProducts();
    }, [getProducts]);

    return (
        <Stack
            spacing={isMobile ? 2 : 3} // Adjust spacing based on screen size
            sx={{
                padding: isMobile ? '10px' : '20px', // Adjust padding for mobile and desktop
                backgroundColor: isMobile ? '#f9f9f9' : '#fff', // Optional: Different background for mobile
            }}
        >
            {
                products.map((item, index) => (
                    <ProductItem
                        product={item}
                        key={index.toString()}
                        sx={{
                            boxShadow: isMobile ? 'none' : '0px 4px 10px rgba(0, 0, 0, 0.1)', // Optional: Shadow for desktop
                            borderRadius: isMobile ? '0px' : '8px', // Optional: Rounded corners for desktop
                        }}
                    />
                ))
            }
        </Stack>
    );
};

export default ProductTab;